import type { Action } from "../actions.types";

/**
 * Check if action is available (not past closed_date).
 */
export function isActionAvailable(action: Action): boolean {
  if (!action.closed_date) return true;
  return new Date(action.closed_date) > new Date();
}

